/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { AppNotification, Notification } from './@types';

export interface NotificationContextValue {
  notify: (notification: Notification) => void;
  notifyById: (notification: AppNotification) => void;
}

export const NotificationContext = React.createContext<NotificationContextValue>({
  notify: () => {},
  notifyById: () => {},
});
